import { action } from "@reatom/framework";
import { getMeTelegramRequest } from "src/pages/ProfilePage/widgets/UserDataWidget/store/fetchers";
import { toastHandler } from "src/util";
import { sendBitrixForm } from "src/util/sendBitrixForm";

import { getMeRequest } from "../fetchers";

export const sendBitrixDataAction = action(async (ctx) => {
  const userData = ctx.get(getMeRequest.dataAtom);
  const telegramInfo = ctx.get(getMeTelegramRequest.dataAtom);

  if (!userData) return;

  try {
    await sendBitrixForm(userData, telegramInfo);

    toastHandler.success({
      title: "Заявка успешно отправлена",
      name: "sendBitrixFormSuccess",
    });
  } catch (error) {
    toastHandler.error({
      title: "Не удалось отправить заявку",
      content: error instanceof Error ? error.message : String(error),
      name: "sendBitrixFormError",
    });
  }
}, "sendBitrixDataAction");
